import { render, staticRenderFns } from "./client-table.vue?vue&type=template&id=3f960866&scoped=true&"
import script from "./client-table.vue?vue&type=script&lang=js&"
export * from "./client-table.vue?vue&type=script&lang=js&"
import style0 from "./client-table.vue?vue&type=style&index=0&id=3f960866&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f960866",
  null
  
)

export default component.exports